module.exports = __webpack_public_path__ + "static/media/Bettdecke_140x200_Kissen_80x80.70c71e07.png";